import { ApiClient } from "@/api/shared/api-client";
import type { Season, UpdateSeasonSettingsPayload } from "@/features/seasons/models/season";
import type { ApiResponse } from "@/models/api-response";

export class SeasonsClient extends ApiClient {
  public getSeasonsList({
    productToken,
    sport,
    organizationId,
    limit,
    offset,
    nameContains,
  }: {
    productToken: string;
    sport: string;
    organizationId: string;
    limit: number;
    offset: number;
    nameContains?: string;
  }): Promise<ApiResponse<Season[]>> {
    return this.get<Season[]>({
      url: `/v1/${sport}/organizations/${organizationId}/seasons`,
      params: { limit, offset, nameContains },
      headers: {
        Authorization: `Bearer ${productToken}`,
      },
    });
  }

  public updateSeasonSettings({
    productToken,
    sport,
    organizationId,
    payload,
  }: {
    productToken: string;
    sport: string;
    organizationId: string;
    payload: UpdateSeasonSettingsPayload;
  }): Promise<ApiResponse<{ success: boolean }>> {
    return this.patch<{ success: boolean }>({
      url: `/v1/${sport}/organizations/${organizationId}/seasons`,
      data: payload,
      headers: {
        Authorization: `Bearer ${productToken}`,
      },
    });
  }
}
